<ul class="grid-mini-button-container">

  <li>
    <button mat-button
            class="grid-mini-button" matTooltip="Click here to download the Memo"  (click)="onClicked('GenerateCbCMemo')"> <i class="fa-solid fa-memo"></i> Memo
    </button>
  </li>
</ul>
